import React from 'react'
import { useIntl } from 'react-intl'
import { useGetValueAdded } from '../../services/hooks'
import { UClick } from '../common/utils'
import { getValueAddedNameId } from '../Cart/ecardOrderItemUtils'

import styles from './ValueAddedServices.module.css'

const CARD_TYPE = '实体卡85折'

const ValueAddedServices = ({ valueAdded, setValueAdded, onResult = () => {}, page }) => {
  const { formatMessage } = useIntl()
  const { data, loading } = useGetValueAdded({
    onSuccess: () => {
      onResult()
    },
  })

  const findChecked = (title) => {
    return valueAdded.find((item) => item.title === title)
  }

  const setCheckedStatus = (item) => {
    if (findChecked(item.title)) {
      const newList = valueAdded.filter((v) => v.title !== item.title)
      setValueAdded(newList)
    } else {
      UClick(`clickAdded-${page}-${item.type}`)
      setValueAdded([...valueAdded, item])
    }
  }

  if (loading || (data && data.length === 0)) return null

  return (
    <>
      <div className={styles.title}>折扣卡优惠加购</div>
      <div className={styles.cards}>
        {data.map((item) => {
          // 展示名与结算弹窗明细共用同一套映射（getValueAddedNameId）：i18n key 按语言渲染，
          // 未知标题（后端新增类型）原样回退展示
          const nameId = getValueAddedNameId(item.title)
          return (
            <div className={styles['card-box']} key={item.title}>
              <div className={styles.left}>
                <div className={styles['item-title']}>{nameId ? formatMessage({ id: nameId }) : item.title}</div>
                <div className={styles.desc}>
                  {item.title === CARD_TYPE
                    ? '购买后，一年内可享购买卡面85折，限额5张'
                    : '一年内可享 12张周边商品8折优惠'}
                </div>
              </div>
              <div className={styles.right}>
                <span className={styles.price}>￥{item.price.toFixed(2)}</span>
                <div
                  className={findChecked(item.title) ? styles.checked : styles['not-checked']}
                  onClick={() => setCheckedStatus(item)}
                >
                  {findChecked(item.title) && (
                    <img src={require('../../assets/images/buy_cards/check-circle.png')} alt="checked" />
                  )}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default ValueAddedServices
